/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientProduct } from '../models/ClientProduct';
import type { PaginatedClientProductList } from '../models/PaginatedClientProductList';
import type { PatchedClientProduct } from '../models/PatchedClientProduct';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsProductsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedClientProductList
     * @throws ApiError
     */
    public clientsProductsList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedClientProductList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-products/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns ClientProduct
     * @throws ApiError
     */
    public clientsProductsCreate({
        requestBody,
    }: {
        requestBody: ClientProduct,
    }): CancelablePromise<ClientProduct> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients-products/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ClientProduct
     * @throws ApiError
     */
    public clientsProductsRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this client product.
         */
        id: number,
    }): CancelablePromise<ClientProduct> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-products/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ClientProduct
     * @throws ApiError
     */
    public clientsProductsUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this client product.
         */
        id: number,
        requestBody: ClientProduct,
    }): CancelablePromise<ClientProduct> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients-products/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ClientProduct
     * @throws ApiError
     */
    public clientsProductsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this client product.
         */
        id: number,
        requestBody?: PatchedClientProduct,
    }): CancelablePromise<ClientProduct> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clients-products/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public clientsProductsDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this client product.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients-products/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
